module.exports = __webpack_public_path__ + "img/zendesk.c60e068e.png";